import { useEffect } from 'react';
import { IRootState } from '../../../store';
import { useDispatch, useSelector } from 'react-redux';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { resetQueuePromoCount } from '../../../store/emarsys/action';
import keepAliveAPI from '../../../helpers/utils/keepAliveAPI';

const useSendGOPromo = () => {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isFlagPromoListActive = getFlagValue(FLAG_ENUM.EMARSYS_PROMO_LIST);
  const isPromoActive = getFlagValue(FLAG_ENUM.EMARSYS_PROMO);
  const isSubmitLeadsActive = getFlagValue(FLAG_ENUM.EMARSYS_SUBMIT_LEADS);
  const dispatch = useDispatch();
  const { queuePromoCount } = useSelector((state: IRootState) => state.emarsys) || {
    queuePromoCount: 0,
  };
  useEffect(() => {
    keepAliveAPI();
    const handleBeforeUnload = () => {
      if (
        sessionStorage.getItem('push_go') === '1' &&
        isFlagActive &&
        (isPromoActive || isFlagPromoListActive || isSubmitLeadsActive)
      ) {
        ScarabQueue.push(['go']);
        dispatch(resetQueuePromoCount());
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const sendGo = setTimeout(() => {
      if (
        sessionStorage.getItem('push_go') === '1' &&
        isFlagActive &&
        (isPromoActive || isFlagPromoListActive || isSubmitLeadsActive)
      ) {
        ScarabQueue.push(['go']);
        dispatch(resetQueuePromoCount());
      }
    }, 1000);
    return () => clearTimeout(sendGo);
  }, [queuePromoCount]);

  return null;
};

export default useSendGOPromo;
